// src/features/learner/components/ContentRenderers/MultipleResponseRenderer.js
import React from 'react';

export const MultipleResponseRenderer = ({ 
    unit, 
    userAnswers, 
    showFeedback, 
    onAnswerSelect, 
    onCheckAnswer,
    onMarkCompleted,
    onResetUnit,
    getRandomizedOptions 
}) => {
    const content = unit.content || {};
    const showFeedbackForUnit = showFeedback[unit.id];
    const userAnswer = userAnswers[unit.id] || [];

    // Calculate correctness once at render time — used both in feedback display and reset button
    const correctOptions = content.options?.filter(o => o.isCorrect).map(o => o.id) || [];
    const allCorrectSelected = correctOptions.every(id => userAnswer.includes(id));
    const noWrongSelected = userAnswer.every(id => correctOptions.includes(id));
    const isCorrect = allCorrectSelected && noWrongSelected;

    // Get randomized options for this unit
    const displayOptions = getRandomizedOptions ? 
        getRandomizedOptions(unit.id, content.options) : 
        content.options || [];

    const handleMultipleSelect = (optionId) => {
        if (showFeedbackForUnit) return;

        let newAnswer;
        if (userAnswer.includes(optionId)) {
            newAnswer = userAnswer.filter(id => id !== optionId);
        } else {
            newAnswer = [...userAnswer, optionId];
        }

        if (onAnswerSelect) {
            onAnswerSelect(unit.id, newAnswer);
        }
    };

   const handleCheckAnswer = () => {
    if (onMarkCompleted) onMarkCompleted(unit.id, null, isCorrect ? 'correct' : 'wrong');
    if (onCheckAnswer) onCheckAnswer(unit.id);
};

    const isFormValid = userAnswer && userAnswer.length > 0;

    return (
        <div className="unit-content multiple-response-content">
            

            <div className="multiple-response-stem">
                <div dangerouslySetInnerHTML={{ __html: content.stem || '' }} />
            </div>

            <div className="multiple-response-options">
                {displayOptions.map(option => (
                    <div
                        key={option.id}
                        className={`multiple-response-option ${
                            userAnswer.includes(option.id) ? 'selected' : ''
                        } ${
                            showFeedbackForUnit && option.isCorrect ? 'correct' : ''
                        } ${
                            showFeedbackForUnit && userAnswer.includes(option.id) && !option.isCorrect
                                ? 'incorrect'
                                : ''
                        }`}
                        onClick={() => handleMultipleSelect(option.id)}
                    >
                        <div className="checkbox">
                            {userAnswer.includes(option.id) && <span className="checkbox-mark">✓</span>}
                        </div>
                        <div className="option-text">{option.text}</div>
                    </div>
                ))}
            </div>

            {!showFeedbackForUnit ? (
                <button
                    className="check-answer-button"
                    onClick={handleCheckAnswer}
                    disabled={!isFormValid}
                >
                    Check Answer
                </button>
            ) : (
                <div className={`feedback-container ${isCorrect ? 'correct' : 'incorrect'}`}>
                    <div className="feedback-header">
                        {isCorrect ? 'Correct!' : 'Incorrect'}
                    </div>
                    <div className="feedback-text">
                        {content.generalFeedback}
                    </div>
                    {!isCorrect && onResetUnit && (
                        <div style={{ textAlign: 'center', marginTop: '12px' }}>
                            <button
                                className="reset-button"
                                onClick={() => onResetUnit(unit.id)}
                                title="Try again"
                                style={{
                                    padding: '8px 12px', fontSize: '18px',
                                    backgroundColor: '#6c757d', color: 'white',
                                    border: 'none', borderRadius: '50%', cursor: 'pointer',
                                    width: '40px', height: '40px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    margin: '0 auto', transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}
                            >
                                🔄
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};